import React from "react";

interface ButtonProps {
  icon: React.ReactNode | null;
  label: string;
  onClick: () => void;
  align?: "left" | "center";
  disabled?: boolean;
  hideLabelOnMd?: boolean;
}

interface ButtonComponentProps extends ButtonProps {
  variant: "primary" | "secondary";
}

function Button({
  icon,
  label,
  onClick,
  align = "center",
  variant = "secondary",
  disabled = false,
  hideLabelOnMd = false,
}: ButtonComponentProps) {
  const alignment: string =
    align === "left" ? "justify-start" : "justify-center";

  const variantStyles = {
    primary: "bg-primary-blue text-white hover:bg-blue-400",
    secondary: "bg-white hover:bg-slate-300",
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`flex items-center ${alignment} gap-2 w-full py-2 px-4 rounded-full transition-colors ${
        variantStyles[variant]
      } ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
    >
      {icon}
      <span className={hideLabelOnMd ? "hidden md:inline" : ""}>{label}</span>
    </button>
  );
}

export function PrimaryButton(props: ButtonProps) {
  return <Button {...props} variant="primary" />;
}

export function SecondaryButton(props: ButtonProps) {
  return <Button {...props} variant="secondary" />;
}
